<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonTableStyles contractInfo">
            <van-nav-bar
                left-arrow
                @click-left="onClickLeft"
            >
                <template #title>
                    <van-tabs @click="changeList">
                        <van-tab :title="isLeader?'合同查询':'合同信息'"></van-tab>
                        <van-tab title="已关注合同"></van-tab>
                    </van-tabs>
                </template>
                <template #right>
                    <span
                        class="iconfont iconshaixuan1"
                        @click="showSearch"
                    ></span>
                </template>
            </van-nav-bar>
            <section>
                <!-- <van-search v-model="Keywords" placeholder="请输入搜索信息" @change="search"></van-search> -->
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        :finished="finished"
                        finished-text="没有更多了!"
                        @load="onLoad"
                        v-if="is_attention===0"
                    >
                        <ul class="list">
                            <li v-for="(item,index) in listData" :key="item.contract_number + index" :class="`item-${item.contract_type}`">
                                <div class="engineeringInfo" @click="openDetails(item)">
                                    <h4 class="engineeringInfo_header">
                                        <span class="state">{{ item.contract_type | contractType }}</span>
                                        <span class="headerName">合同编号：{{ item.contract_number }}</span>
                                        <strong class="contractStatus" @click.stop="alertTip(item)">
                                            {{ item.control_status | controlStatus }}
                                        </strong>
                                    </h4>
                                    <div class="engineeringInfo_content">
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                            <span>工程名称：{{ item.engineering_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                            <span>签订日期：{{ item.signing_date }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                            <span>客户名称：{{ item.client_name }} </span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                            <span>客户联系人：{{ item.client_contact_name }} ({{ item.client_contact_phone }})</span>
                                        </p>
                                        <!-- <p>
                                            <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                            <span>审批状态：{{ approval_status[item.approval_status] }}</span>
                                        </p> -->
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                            <span>合同状态：{{ item.contract_status | contractStatusName }}</span>
                                        </p>
                                    </div>
                                    <div class="btns-con">
                                        <div @click.stop="toControlData(item.contract_number)" v-if="$store.state.versionMark == 2">
                                            <i class="btn">管控数据</i>
                                        </div>
                                        <div @click.stop="toContractAchives(item.contract_number)">
                                            <i class="btn">合同档案</i>
                                        </div>
                                        <div>
                                            <div
                                                class="btn star-btn"
                                                v-if="item.is_attention===2"
                                                @click.stop="handleStar(item)"
                                            >
                                                <i class="iconfont iconxin"></i>
                                                <i>关注</i>
                                            </div>
                                            <div
                                                class="btn stared-btn"
                                                v-else
                                                @click.stop="handleStar(item)"
                                            >
                                                <i class="iconfont iconxin1"></i>
                                                <i>已关注</i>
                                            </div>
                                        </div>
                                    </div>
                                    <button class="telephone" @click.stop="openContactInfo(item)"></button>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                    <van-list v-else>
                        <ul class="list">
                            <li v-for="(item,index) in attentionListData" :key="item.contract_number + index" :class="`item-${item.contract_type}`">
                                <div class="engineeringInfo" @click="openDetails(item)">
                                    <h4 class="engineeringInfo_header">
                                        <span class="state">{{ item.contract_type | contractType }}</span>
                                        <span class="headerName">合同编号：{{ item.contract_number }}</span>
                                        <strong class="contractStatus" @click.stop="alertTip(item)">
                                            {{ item.control_status | controlStatus }}
                                        </strong>
                                    </h4>
                                    <div class="engineeringInfo_content">
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                            <span>工程名称：{{ item.engineering_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                            <span>签订日期：{{ item.signing_date }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                            <span>客户名称：{{ item.client_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                            <span>客户联系人：{{ item.client_contact_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_3.png" alt="">
                                            <span>客户联系电话：{{ item.client_contact_phone }}</span>
                                        </p>
                                    </div>
                                    <div class="btns-con">
                                        <div @click.stop="toControlData(item.contract_number)" v-if="$store.state.versionMark == 2">
                                            <i class="btn">管控数据</i>
                                        </div>
                                        <div @click.stop="toContractAchives(item.contract_number)">
                                            <i class="btn">合同档案</i>
                                        </div>
                                        <div>
                                            <div
                                                class="btn star-btn"
                                                v-if="item.is_attention===2"
                                                @click.stop="handleAttentionStar(item)"
                                            >
                                                <i class="iconfont iconxin"></i>
                                                <i>关注</i>
                                            </div>
                                            <div
                                                class="btn stared-btn"
                                                v-else
                                                @click.stop="handleAttentionStar(item)"
                                            >
                                                <i class="iconfont iconxin1"></i>
                                                <i>已关注</i>
                                            </div>
                                        </div>
                                    </div>
                                    <button class="telephone" @click.stop="openContactInfo(item)"></button>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
                <van-action-sheet
                    v-model="actionSheetShow"
                    cancel-text="取消"
                    class="contactInfo"
                >
                    <h5>{{ info.client_contact_name }}</h5>
                    <p @click="phone(info.client_contact_phone)">
                        {{ info.client_contact_phone }}
                    </p>
                </van-action-sheet>
                <van-dialog
                    v-model="dialogShow"
                    show-cancel-button
                    confirm-button-text="超发申请"
                    confirm-button-color="#E60000"
                >
                    <img src="@/assets/images/contractInfo/caution@2x.png">
                    <p>当前合同余额不足，已面临超限发货！</p>
                </van-dialog>
                <van-dialog
                    v-model="showContrlMsg"
                    :show-confirm-button="true"
                    :show-cancel-button="false"
                    class="contrlMsgDialog"
                >
                    <ul>
                        <li v-for="(item, index) in contrlMsg" :key="index">
                            <div class="con">
                                <h4>
                                    <span v-if="item.control_type===2">告警原因</span>
                                    <span v-else>通知内容</span>
                                    <span>{{ item.control_start_time }}</span>
                                </h4>
                                <p>
                                    {{ item.control_reason }}
                                </p>
                            </div>
                            <div class="split"></div>
                        </li>
                    </ul>
                </van-dialog>
            </section>
            <van-popup
                class="sideslip"
                v-model="popupShow"
                position="right"
                :style="{ width: '80%',height: '100%' }"
            >
                <div class="screen">
                    <van-nav-bar
                        title="筛选"
                        right-text="取消"
                        @click-right="onClickRight"
                    >
                    </van-nav-bar>
                    <section>
                        <dl>
                            <dt>搜索条件</dt>
                            <dd>
                                <van-field v-model="Keywords" placeholder="请输入搜索信息"></van-field>
                            </dd>
                        </dl>
                        <dl>
                            <dt>合同分类</dt>
                            <dd>
                                <span
                                    :class="{'active': activeContractType===index}"
                                    v-for="(item, index) in contractTypes"
                                    :key="item.code"
                                    @click="changeContractType(item,index)"
                                >
                                    {{ item.name }}
                                </span>
                            </dd>
                        </dl>
                        <dl>
                            <dt>最近供货时间</dt>
                            <dd>
                                <span
                                    :class="{'active': activeSupplyTime===index}"
                                    v-for="(item, index) in supplyTimes"
                                    :key="`supplyTimes_${index}`"
                                    @click="changesupplyTime(item,index)"
                                >
                                    {{ item.name }}
                                </span>
                            </dd>
                        </dl>
                        <dl>
                            <dt>合同状态</dt>
                            <dd>
                                <span
                                    :class="{'active': item.contract_status===contract_status}"
                                    v-for="item in contractStatusLs"
                                    :key="item.contract_status"
                                    @click="changeContractStatus(item)"
                                >
                                    {{ item.name }}
                                </span>
                            </dd>
                        </dl>
                        <dl>
                            <dt>场站</dt>
                            <dd>
                                <span
                                    :class="{'active': item.station_id===station_id}"
                                    v-for="item in stationLs"
                                    :key="item.station_id"
                                    @click="handleSelectStation(item)"
                                >
                                    {{ item.name }}
                                </span>
                            </dd>
                        </dl>
                    </section>
                    <div class="bottom">
                        <div class="sure-btn" @click="search">
                            确定
                        </div>
                        <div class="reset-btn" @click="handleReset">
                            重置
                        </div>
                    </div>
                </div>
            </van-popup>
            <!-- <van-overlay :show="showOverlay">
                <van-loading type="spinner" color="#fff"></van-loading>
            </van-overlay> -->
        </div>
    </v-touch>
</template>

<script>
let _that;

export default {
    // 合同信息
    name: 'contract-info',
    components: {},
    props: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'contract-info');
        }
        next();
    },
    data() {
        return {
            // 搜索条件
            Keywords: '',
            // 下拉login状态
            isLoading: false,
            // 上拉login状态
            isUpLoading: false,
            // 是否加载完数据
            finished: false,
            // 联系人上拉菜单状态
            actionSheetShow: false,
            // 当前任务联系人
            info: {},
            // 超期提示弹出状态
            dialogShow: false,
            // 分页
            pageindex: 0,
            // 列表数据
            listData: [],
            // 已关注列表
            attentionListData: [],
            // 列表总条数
            total: 0,
            // 是否是领导端
            isLeader: false,
            // 管控消息
            contrlMsg: [],
            showContrlMsg: false,
            // 筛选条件
            popupShow: false,
            // 合同类型条件
            contract_type: '',
            // 时间范围
            date_range: 0,
            // 是否关注
            is_attention: 0,
            // 合同类型集合
            contractTypes: [],
            // 选中合同类型
            activeContractType: -1,
            // 时间范围集合
            supplyTimes: [
                {
                    code: 0,
                    name: '全部',
                },
                {
                    code: 1,
                    name: '一个月',
                },
                {
                    code: 2,
                    name: '3个月',
                },
                {
                    code: 3,
                    name: '半年内',
                },
                {
                    code: 4,
                    name: '半年以上',
                },
            ],
            // 选中时间范围
            activeSupplyTime: 0,
            approval_status: {
                0: '未启动',
                1: '审批中',
                2: '审批通过',
                3: '审批未通过',
            },

            contract_status: '',
            contractStatusLs: [{ contract_status: '', name: '全部' }],
            // 选中的场站
            station_id: '',
            // 场站列表
            stationLs: [{ station_id: '', name: '全部' }],
        };
    },
    beforeCreate() {
        _that = this;
    },
    filters: {
        controlStatus(status) {
            const arr = {
                // 0: '正常',
                1: '预警中',
                2: '已告警',
                3: '处置中',
                4: '已解锁',
            };
            return arr[status];
        },
        contractType(type) {
            const arr = {
                '102-LS1': '临供',
                '102-LS2': '零售',
                '102-XX0': '预付款',
                '102-ZS0': '垫资',
            };
            return arr[type];
        },
        // 合同状态
        contractStatusName(status) {
            status = status.toString();
            return _that.contractStatusLs.filter(item => item.contract_status === status)[0].name;
        },
    },
    computed: {},
    watch: {},
    async created() {
        // 是否是领导端
        this.isLeader = this.$route.query.leader || this.$route.query.areaLeader;
        await this.getContractStatus();
    },
    mounted() {
        this.getContractTypes();
        this.getStationData();
    },
    destroyed() {},
    methods: {
        // 获取请求接口
        getApiField() {
            // this.$route.query.leader
            let url = '';
            if (this.$route.query.leader) {
                // 领导
                url = 'get_page_leader';
            } else if (this.$route.query.areaLeader) {
                // 区域领导
                url = 'get_page_area_leader';
            } else {
                url = 'get_page';
            }
            return url;
        },

        getInit() {
            // 获取合同列表
            const url = this.getApiField();
            this.$axios
                .get(`/interfaceApi/sale/contract_manager/${url}?pageindex=`
                 + this.pageindex + '&pageSize=3&Keywords=' + this.Keywords
                 + '&contract_type=' + this.contract_type + '&date_range=' + this.date_range
                 + '&is_attention=' + this.is_attention + '&station_id=' + this.station_id
                 + '&contract_status=' + this.contract_status
                )
                .then(res => {
                    this.total = res.total;
                    if (this.listData.length < 1) {
                        this.listData = res.rows;
                        this.finished = false;
                    } else {
                        this.listData.push(...res.rows);
                    }
                    if (this.listData.length === this.total) {
                        this.finished = true;
                    }
                    this.isLoading = false;
                    this.isUpLoading = false;
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 获取关注列表
        getAttentionList() {
            // 获取合同列表
            const url = this.getApiField();
            this.$axios
                .get(`/interfaceApi/sale/contract_manager/${url}?pageindex=`
                 + 1 + '&pageSize=10000&Keywords=' + this.Keywords
                 + '&contract_type=' + this.contract_type + '&date_range=' + this.date_range
                 + '&is_attention=' + this.is_attention + '&station_id=' + this.station_id
                )
                .then(res => {
                    this.attentionListData = res.rows;
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/home' });
        },
        // 筛选条件-取消
        onClickRight() {
            this.popupShow = false;
            this.handleReset();
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/home' });
        },
        // 下拉刷新
        onRefresh() {
            this.pageindex = 1;
            this.listData = [];
            this.finished = false;
            this.isLoading = false;
            if (this.is_attention === 0) {
                this.getInit();
            } else {
                this.getAttentionList();
            }
        },
        // 上拉加载更多
        onLoad() {
            this.$nextTick(() => {
                this.pageindex++;
                this.getInit();
            });
        },
        showSearch() {
            this.popupShow = true;
        },
        // 搜索
        search() {
            if (this.is_attention === 0) {
                this.pageindex = 1;
                this.finished = false;
                this.listData = [];
                this.getInit();
            } else {
                this.attentionListData = [];
                this.getAttentionList();
            }
            this.popupShow = false;
        },
        // 重置
        handleReset() {
            this.activeContractType = -1;
            this.activeSupplyTime = 0;
            this.Keywords = '';
            this.contract_type = '';
            this.date_range = 0;
            this.contract_status = '';
        },
        // 切换列表
        changeList(name) {
            this.is_attention = name;
            this.handleReset();
            if (this.is_attention === 0) {
                this.pageindex = 1;
                this.finished = false;
                this.listData = [];
                this.getInit();
            } else {
                this.getAttentionList();
            }

        },
        // 筛选-切换合同类型
        changeContractType(data, index) {
            this.activeContractType = index;
            this.contract_type = data.code;
        },
        // 筛选-切换供货时间
        changesupplyTime(data, index) {
            this.activeSupplyTime = index;
            this.date_range = index;
        },
        // 选择筛选条件 场站
        handleSelectStation(item) {
            this.station_id = item.station_id;
        },
        // 获取场站数据
        async getStationData() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationLs = stationIds.map((id, index) => {
                    return {
                        station_id: id,
                        name: stationNames[index],
                    };
                });
                this.stationLs.push(...stationLs);
            }
        },
        // 合同状态变更
        changeContractStatus(item) {
            this.contract_status = item.contract_status;
        },
        // 获取获取合同状态字典
        async getContractStatus() {
            const path = '/interfaceApi/sale/contract_manager/get_dictionary?groupCode=contract_status';
            this.$axios.get(path)
                .then(data => {
                    const list = data.map(item => {
                        return {
                            contract_status: item.dic_code,
                            name: item.dic_name,
                        };
                    });
                    this.contractStatusLs.push(...list);
                });
        },
        // 打开联系人信息上拉菜单
        openContactInfo(item) {
            this.info = item;
            this.actionSheetShow = true;
        },
        // 点击合同
        noticeClick() {
            this.dialogShow = true;
        },
        // 弹出管控原因
        alertTip(item) {
            this.$axios
                .get('/interfaceApi/sale/control/control_message/' + item.contract_number)
                .then(res => {
                    if (res) {
                        this.contrlMsg = res;
                        this.showContrlMsg = true;
                    }
                })
                .catch(error => {
                    this.$toast({ message: error.ErrorCode.Message });
                });
        },
        // 打开合同详情
        openDetails(item) {
            this.$router.isBack = 2;
            if (this.$store.state.versionMark === '1') {
                this.$router.push({ name: 'contractDetailsBasics', params: { obj: item } });
            } else {
                this.$router.push({ name: 'contractDetails', params: { obj: item } });
            }

        },
        // 调用打电话功能
        phone(phoneNumber) {
            this.$callMobile('JYTeamsNative', 'jyMakePhoneCall', phoneNumber);
            this.actionSheetShow = false;
        },
        // 合同档案
        toContractAchives(contract_number) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'contractAchrives', params: { contract_number: contract_number } });
        },
        // 跳转到管控界面
        toControlData(contract_number) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'controlData', params: { contract_number: contract_number } });
        },
        // 关注、取消关注
        handleStar(item) {
            let url = '';
            if (item.is_attention === 1) {
                url = '/interfaceApi/sale/contract_manager/delete_attention/' + item.contract_number;
            } else {
                url = '/interfaceApi/sale/contract_manager/add_attention/' + item.contract_number;
            }
            this.$axios
                .get(url)
                .then(res => {
                    if (res) {
                        if (item.is_attention === 1) {
                            this.$toast('取消关注成功');
                            item.is_attention = 2;
                        } else {
                            this.$toast('关注成功');
                            item.is_attention = 1;
                        }
                    }
                })
                .catch(error => {
                    this.$toast({ message: error.ErrorCode.Message });
                });
        },
        handleAttentionStar(item) {
            let url = '';
            if (item.is_attention === 1) {
                url = '/interfaceApi/sale/contract_manager/delete_attention/' + item.contract_number;
            } else {
                url = '/interfaceApi/sale/contract_manager/add_attention/' + item.contract_number;
            }
            this.$axios
                .get(url)
                .then(res => {
                    if (res) {
                        if (item.is_attention === 1) {
                            this.$toast('取消关注成功');
                            item.is_attention = 2;
                            let deleIndex = -1;
                            this.attentionListData.map((v, vIndex) => {
                                if (item.cvid === v.cvid) {
                                    deleIndex = vIndex;
                                }
                            });
                            this.attentionListData.splice(deleIndex, 1);
                        } else {
                            this.$toast('关注成功');
                            item.is_attention = 1;
                        }
                    }
                })
                .catch(error => {
                    this.$toast({ message: error.ErrorCode.Message });
                });
        },
        // 获取合同类型
        getContractTypes() {
            this.$axios
                .get('/interfaceApi/baseinfo/dictionary_config/getlist?parent_code=102')
                .then(res => {
                    if (res) {
                        res.map(item => {
                            if (item.name === '临时赊销合同') {
                                item.name = '临销合同';
                            }
                            if (item.name === '正式赊销合同') {
                                item.name = '正式合同';
                            }
                        });

                        this.contractTypes = res;
                    }
                })
                .catch(error => {
                    this.$toast({ message: error.ErrorCode.Message });
                });
        },
    },
};
</script>
<style lang="stylus">
.contrlMsgDialog
    .van-dialog__content
        text-align left!important
        padding 0!important
    ul
        li
            .con
                padding 15rpx
                h4
                    display flex
                    justify-content space-between
                    >span
                        &:first-child
                            font-size 16rpx
                            color #E60000
                        &:last-child
                            font-size 12rpx
                            color #666666
                p
                    font-size 14rpx!important
                    margin-top 10rpx!important
            .split
                height 15rpx
                background #F0F0F0

.contractInfo
    height 100%
    .van-nav-bar
        display flex
        .iconshaixuan1
            font-size 20rpx
            color #ffffff
            margin-right 10rpx
        .van-nav-bar__content
            width 100%
        .van-nav-bar__right
            top 0
        .van-nav-bar__title
            max-width 100%
            .van-tabs
                .van-tabs__nav
                    background rgba(0,0,0,0)
                    .van-tab
                        flex-basis auto !important
                        font-size 14rpx
                        margin 0 6rpx
                        line-height 44rpx
                        color rgba(240,240,240,0.5)
                        transition 0.2s
                        &.van-tab--active
                            font-size 16rpx
                            line-height 44rpx
                            color #FFFFFF
                        .van-tab__text
                            white-space nowrap
                    .van-ellipsis
                        text-overflow initial
                    .van-tabs__line
                        display none
                .van-tabs__wrap
                    &:after
                        display none
        .van-ellipsis
            white-space normal
    section
        height calc(100% - 45rpx)
        .van-pull-refresh
            height 100%
            overflow: scroll;
            -webkit-overflow-scrolling: touch;
            .list
                li
                    .telephone
                        width 25rpx
                        height 25rpx
                        background url(./../../../assets/images/clueManagement/phone@2x.png)
                        background-size 100% 100%
                        border none
                        position absolute
                        right 15rpx
                        top 165rpx
    .contactInfo
        h5,p
            font-size 16rpx
            line-height 45rpx
            text-align center
        h5
            color #333333
            background #F8F8F8
        p
            color #0189FC
            border-bottom 1px solid  #F0F0F0
            a
                color #0189fc
    .van-dialog
        .van-dialog__content
            padding 15rpx
            text-align center
            img
                width 40rpx
                height 40rpx
            p
                font-size 14rpx
                color #333333
                margin-top 15rpx
    .screen
        height 100%
        section
            height calc(100% - 85rpx)
            overflow scroll
            -webkit-overflow-scrolling touch
            dd
                margin-top 8rpx
                display flex
                flex-wrap wrap
                .van-field
                    border 1px solid #ddd
                    padding 6rpx 10rpx
                >span
                    width calc(33.33% - 10rpx)
                    background #F1F1F1
                    border 1px solid #F1F1F1
                    border-radius 6rpx
                    margin 0 10rpx 10rpx 0
                    font-size 14rpx
                    text-align center
                    padding 6rpx 0
                    display flex
                    justify-content center
                    align-items center
                    &:last-child
                        margin-right 0
                    &.active
                        border 1px solid #E60000
                        color #E60000
                        background #fff
                        position relative
                        &:after
                            position absolute
                            content ''
                            bottom 0
                            right -1px
                            width 20rpx
                            height 20rpx
                            background url(./../../../assets/images/contractInfo/pick.png) no-repeat
                            background-size 100% 100%
        .bottom
            height 40rpx
            display flex
            font-size 18rpx
            text-align center
            line-height 40rpx
            .sure-btn
                flex 1
                background #E60000
                height 100%
                border 1px solid #E60000
                color #fff
            .reset-btn
                flex 1
                height 100%
                border 1px solid #E60000
                color #E60000
</style>
